import api from '@/utils/http/axios'
import { NO_PREFIX_URL } from '@/utils/http/base-url'

/**
 * 获取当前客户的企业名称
 * @param {string} cstNo customerno
 * @param {string} currentBusinessCode 10101234 固定值
 */
export function getCustName (params = {}, config = {}) {
  return api.post(`${NO_PREFIX_URL}/getCustName.do`, params, config, 'URLEncoded')
}

/**
 * 获取当前币种的管理费
 * @param {string} cryType
 */
export function getManageFee (params = {}, config = {}) {
  return api.get(`${NO_PREFIX_URL}/api/fee/inf.do`, params, config, 'URLEncoded')
}
/**
 * 获取币种列表
 * @param {string} cryType
 */
export function getCurrencyList (params = {}, config = {}) {
  return api.get('/api/config/currency/list', params, config)
}
/**
 * 获取账户申请列表
 * @param {string} cstNo customerno
 */
export function getOpenApplies (params = {}, config = {}) {
  return api.post('/api/getOpenApplies', params, config, 'URLEncoded')
}

/**
 * 确认开户信息
 * custId
 * @param {string} params.custName
 * @param {string} params.aliasName
 * @param {string} params.currencyType
 * @param {string} params.accountType
 * @param {string} params.currentBusinessCode 10101234
 * @param {string} params.businessCode 10101234
 * @param {string} params.transferName 新币种账户申请
 * @param {string} params.logRecordFlag
 * @param {string} params.session_customerId
 * @param {string} params.session_userId
*/
export function addOpenApply (params = {}, config = {}) {
  return api.post('/cbi-ls-corporbank/api/corporbank/addOpenAccountApply', params, config)
}
